import {
    FileOutlined,
    FolderOutlined,
    MoreOutlined,
    PlusOutlined,
    UploadOutlined
} from '@ant-design/icons';

import {
    Button,
    Card,
    Checkbox,
    Col,
    Dropdown,
    Input,
    Menu,
    message,
    Modal,
    Row,
    Table,
    Typography,
    Upload
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    createFolder,
    deleteFolder,
    fetchFolderList,
    getFolderFiles,
    renameFolder,
    setSliceCurrentFolderId,
    uploadFile
} from "../../redux/rtk/features/document/documentSlice";

import { assignFolderPermission } from '../../redux/rtk/features/document/documentSlice';
import { loadAllStaff } from '../../redux/rtk/features/user/userSlice';
import getUserFromToken from "../../utils/getUserFromToken";


const { Title } = Typography;

const FolderManager = () => {
    const [newFolderName, setNewFolderName] = useState("");
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [renameFolderName, setRenameFolderName] = useState("");
    const [selectedFolder, setSelectedFolder] = useState(null);
    const [selectedFolderId, setSelectedFolderId] = useState(null);
    const [isRenameModalVisible, setIsRenameModalVisible] = useState(false);
    const [isUserListModalVisible, setIsUserListModalVisible] = useState(false);
    const [selectedEditUsers, setSelectedEditUsers] = useState([]);
    const [selectedViewUsers, setSelectedViewUsers] = useState([]);
    const [selectedFolderName, setSelectedFolderName] = useState([]);
    const [currentFolderId, setCurrentFolderId] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userId = getUserFromToken();

    const folders = useSelector((state) => state.document?.folders || []);
    const folderContent = useSelector((state) => state.document?.folderContent || { folders: [], files: [] });
    console.log("folderContent", folderContent);

    const userList = useSelector((state) => state.users?.list || []);
    const [breadcrumbItems, setBreadcrumbItems] = useState([{ title: 'Root', id: 0 }]);

    const cfid = useSelector((state) => state.document.currentFolderId);
    console.log("cfid1????", cfid, "sFID", selectedFolderId, "current", currentFolderId);

    useEffect(() => {
        console.log("cfid", cfid, "sFID", selectedFolderId);
        if (cfid) {
            setCurrentFolderId(cfid)
        }
        dispatch(fetchFolderList(userId));
        dispatch(loadAllStaff({ status: true }));
        dispatch(getFolderFiles(cfid || 0))
    }, [dispatch]);

    useEffect(() => {
        if (folderContent?.folders && selectedFolderId) {
            // Find the selected folder based on selectedFolderId
            const selectedFolder = folderContent.folders.find(folder => folder.id === selectedFolderId);

            if (selectedFolder) {
                // Set view and edit users based on the folder data
                setSelectedViewUsers(selectedFolder.userId || []);
                setSelectedEditUsers(selectedFolder.editFolderUserId || []);
            }
        }
    }, [folderContent, selectedFolderId]);


    const handleAddFolder = () => {
        setNewFolderName("");
        setIsModalVisible(true);
    };
    const handleFileClick = (file) => {
        navigate("/admin/file-viewer", { state: { file: file, parentFolderId: currentFolderId } });
    };

    const handleFolderSubmit = async () => {
        if (newFolderName.trim() !== "") {
            try {
                const result = await dispatch(
                    createFolder({ folderName: newFolderName, userId: userId, parentId: currentFolderId || 0 })
                ).unwrap();
                message.success(result.message);
                setNewFolderName("");
                setIsModalVisible(false);
                dispatch(fetchFolderList(userId));
                dispatch(getFolderFiles(currentFolderId || 0));
            } catch (err) {
                message.error("Failed to create folder");
            }
        }
    };

    const handleRenameFolder = async () => {
        if (!renameFolderName.trim() || !selectedFolder) {
            message.error("Please select a folder and provide a valid new name.");
            return;
        }
        try {
            const result = await dispatch(renameFolder({ oldName: selectedFolder, folderId: selectedFolderId, newFolderName: renameFolderName, parentId: currentFolderId })).unwrap();
            message.success(result.message);
            setRenameFolderName("");
            setSelectedFolder(null);
            setIsRenameModalVisible(false);
            dispatch(getFolderFiles(currentFolderId || 0));
            dispatch(fetchFolderList(userId));
        } catch (err) {
            message.error(err.message || "Failed to rename folder");
        }
    };

    const handleRenameClick = (folderId, folderName) => {
        setSelectedFolder(folderName);
        setRenameFolderName(folderName);
        setSelectedFolderId(folderId);
        setIsRenameModalVisible(true);
    };

    const handleDeleteFolder = async (folderId, folderName) => {
        try {
            const result = await dispatch(deleteFolder({ folderId, folderName })).unwrap();
            message.success(result.message);
            setSelectedFolder(null);
            dispatch(fetchFolderList(userId));
        } catch (err) {
            message.error(err.message || "Failed to delete folder");
        }
    };

    const confirmDeleteFolder = (folderId, folderName) => {
        Modal.confirm({
            title: "Are you sure?",
            content: `Do you really want to delete the folder "${folderName}"? This action cannot be undone.`,
            okText: "Yes, Delete",
            okType: "danger",
            cancelText: "Cancel",
            onOk: () => handleDeleteFolder(folderId, folderName),
        });
    };

    // const handleDeleteFile = async (fileId) => {
    //     try {
    //         await dispatch(deleteFile({ fileId }));
    //         message.success("File deleted successfully!");
    //     } catch (err) {
    //         message.error("Failed to delete file");
    //     }
    // };

    const handleUserListModalOpen = (folderId, folderName) => {
        setSelectedFolderId(folderId);
        setSelectedFolderName(folderName);
        setIsUserListModalVisible(true);
    };

    const handleUserListModalClose = () => {
        setIsUserListModalVisible(false);
    };

    const kebabMenu = (folder) => (
        <Menu>
            <Menu.Item onClick={() => handleRenameClick(folder.id, folder.folderName)}>
                Rename
            </Menu.Item>
            <Menu.Item onClick={() => handleUserListModalOpen(folder.id, folder.folderName)}>
                Assign Permission
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item danger onClick={() => confirmDeleteFolder(folder.id, folder.folderName)}>
                Delete
            </Menu.Item>
        </Menu>
    );


    const filteredUsers = userList
        .filter((user) =>
            `${user.firstName} ${user.lastName}`
                .toLowerCase()
                .includes(searchQuery.toLowerCase())
        )
        .sort((a, b) => a.firstName.localeCompare(b.firstName));

    const handleEditUserChange = (userId, checked) => {
        setSelectedEditUsers((prevEditUsers) => {
            const updatedEditUsers = checked
                ? [...prevEditUsers, userId]
                : prevEditUsers.filter((id) => id !== userId);

            if (checked) {
                // Ensure View is also selected when Edit is selected
                setSelectedViewUsers((prevViewUsers) =>
                    prevViewUsers.includes(userId) ? prevViewUsers : [...prevViewUsers, userId]
                );
            }
            return updatedEditUsers;
        });
    };

    const handleViewUserChange = (userId, checked) => {
        setSelectedViewUsers((prevViewUsers) =>
            checked
                ? [...prevViewUsers, userId]
                : prevViewUsers.filter((id) => id !== userId)
        );

        // If Edit is selected and View is unchecked, remove Edit permission
        if (!checked) {
            setSelectedEditUsers((prevEditUsers) =>
                prevEditUsers.filter((id) => id !== userId)
            );
        }
    };


    const filteredFolders = currentFolderId
        ? folders.filter(folder => folder.parentFolderId === currentFolderId)
        : folders.filter(folder => !folder.parentFolderId);


    const handleOpenFolder = async (folderId) => {
        console.log(`Opening folder with ID: ${folderId}`);
        try {
            // const folder = folders.find(f => f.id === folderId);
            // setBreadcrumbItems(prev => [...prev, { title: folder.folderName, id: folderId }]);
            dispatch(setSliceCurrentFolderId(folderId));
            setCurrentFolderId(folderId);
            await dispatch(getFolderFiles(folderId)).unwrap();
        } catch (error) {
            console.error('Error opening folder:', error);
            message.error('Failed to open folder');
        }
    };


    const handleGoBack = async () => {
        if (currentFolderId) {
            console.log("currentFolderId", currentFolderId);
            console.log("folders", folders);

            try {
                // Find the folder based on currentFolderId
                const foundFolder = folders.find(folder => folder.folder.id === currentFolderId);
                console.log("foundFolder", foundFolder);


                // Check if folder is found and then get parentId
                if (foundFolder) {
                    const parentFolder = foundFolder.folder.parentId;
                    console.log("parentFolder", parentFolder);

                    // Dispatch the actions with parent folder id
                    dispatch(setSliceCurrentFolderId(parentFolder));
                    setCurrentFolderId(parentFolder);
                    await dispatch(getFolderFiles(parentFolder || 0)).unwrap();
                } else {
                    console.error("Folder not found for currentFolderId:", currentFolderId);
                }
            } catch (error) {
                console.error('Error navigating back:', error);
                message.error('Failed to navigate back');
            }
        }
    };

    const uploadProps = {
        customRequest: async ({ file }) => {
            handleFileUpload(file);
        },
        showUploadList: false,
    };


    // Handle file upload
    const handleFileUpload = async (file) => {
        try {
            const result = await dispatch(uploadFile({ file: file, folderId: currentFolderId, uploadedBy: userId })).unwrap();
            message.success(result.message);
            dispatch(getFolderFiles(currentFolderId || 0))
        } catch (err) {
            message.error("File upload failed");
        }
    };


    // const combinedData = [
    //     ...folderContent.folders.map((folder) => ({
    //         id: folder.id,
    //         folderName: folder.folderName,
    //         editFolderUserId: folder.editFolderUserId,
    //         type: 'folder',
    //         children: folder.children || [],
    //     })),
    //     ...folderContent.files.map((file) => ({
    //         id: file.id,
    //         folderName: file.name, // You can display file name instead of folder name
    //         type: 'file',
    //         uploadedBy: file.uploadedBy,
    //         createdAt: file.createdAt,
    //     })),
    // ];

    const allowedFolderIds = new Set(folders.map(folder => folder.id));
    console.log("allowedFolder", allowedFolderIds)
    const combinedData = [
        ...folderContent.folders
            .filter(folder => folder.userId.includes(userId))
            .map((folder) => ({
                id: folder.id,
                folderName: folder.folderName,
                editFolderUserId: folder.editFolderUserId,
                type: 'folder',
                children: folder.children || [],
            })),
        ...folderContent.files.map((file) => ({
            id: file.id,
            folderName: file.name,
            type: 'file',
            uploadedBy: file.uploadedBy,
            createdAt: file.createdAt,
        })),
   ].sort((a, b) => a.folderName.localeCompare(b.folderName, undefined, { sensitivity: 'base' }));
    // const combinedData = [
    //     ...folderContent.folders
    //         // .filter(folder => allowedFolderIds.has(folder.id))  // Only show folders in allowedFolderIds
    //         .filter(folder => {
    //             console.log("Checking folder:", folder.id);
    //             console.log("Is allowed:", allowedFolderIds.has(folder.id));
    //             return allowedFolderIds.has(folder.id);  // Only show folders in allowedFolderIds
    //         })
    //         .map((folder) => ({
    //             id: folder.id,
    //             folderName: folder.folderName,
    //             editFolderUserId: folder.editFolderUserId,
    //             type: 'folder',
    //             children: folder.children || [],
    //         })),
    //     ...folderContent.files.map((file) => ({
    //         id: file.id,
    //         folderName: file.name, // You can display file name instead of folder name
    //         type: 'file',
    //         uploadedBy: file.uploadedBy,
    //         createdAt: file.createdAt,
    //     })),
    // ];


    const columns = [
        {
            title: "Folder Name",
            dataIndex: "folderName",
            key: "folderName",
            render: (text, record) => (
                <div
                    style={{
                        cursor: record.type === 'folder' ? 'pointer' : 'default',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                    // onClick={() => record.type === 'folder' ? handleOpenFolder(record.id) : null}
                    onClick={() => {
                        if (record.type === 'folder') {
                            handleOpenFolder(record.id);
                        } else if (record.type === 'file') {
                            handleFileClick(record);
                        }

                    }}

                >
                    {record.type === 'folder' ? (
                        <FolderOutlined
                            style={{
                                marginRight: 8,
                                color: '#1890ff'
                            }}
                        />
                    ) : (<>
                        <FileOutlined
                            style={{
                                marginRight: 8,
                                color: '#8c8c8c'
                            }}
                        />
                        {/* <DeleteOutlined 
                        onClick={(e) => { 
                            e.stopPropagation(); // Prevent triggering the onClick for the parent div
                            handleDeleteFile(record.id); 
                        }} 
                        style={{ marginLeft: 10, cursor: 'pointer' }} 
                    /> */}
                    </>
                    )}
                    <span style={{
                        fontWeight: 500,
                        color: record.type === 'folder' ? '#1890ff' : '#000'
                    }}>
                        {text}
                    </span>
                </div>
            ),
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
                record.editFolderUserId?.includes(userId) ? (
                    <Row>

                        <Col>
                            <Dropdown overlay={kebabMenu(record)} trigger={["click"]}>
                                <Button icon={<MoreOutlined />} />
                            </Dropdown>
                        </Col>
                    </Row>
                ) : null
            ),
        },

        // {
        //     title: "Actions",
        //     key: "actions",
        //     render: (_, record) => {
        //         console.log("re>>>>", record); // Log the record to the console
        //         return record.editFolderUserId?.includes(userId) ? (
        //             <Row>
        //                 <Col>
        //                     {record.type === 'folder' ? (
        //                         <Dropdown overlay={kebabMenu(record)} trigger={["click"]}>
        //                             <Button icon={<MoreOutlined />} />
        //                         </Dropdown>
        //                     ) : record.type === 'file' ? (
        //                         <Button icon={<DeleteOutlined />} onClick={() => handleDeleteFile(record)} />
        //                     ) : null}
        //                 </Col>
        //             </Row>
        //         ) : null;
        //     },
        // }


    ];

    return (
        <Fragment>
            <Card
                title={
                    <Row justify="space-between" align="middle">
                        {currentFolderId !== 0 ? (
                            <>
                                <Button onClick={handleGoBack}>Back</Button>

                            </>
                        ) : (
                            <>
                                <span>Root folder</span>
                            </>
                        )}

                        <Title level={4} style={{ margin: 0 }}>
                            Folder Management
                        </Title>

                        {currentFolderId !== 0 ? (
                            <>
                                <Upload {...uploadProps}>
                                    <Button type="default" icon={<UploadOutlined />} disabled={currentFolderId === 0}>
                                        Upload File
                                    </Button>
                                </Upload>
                            </>
                        ) : (
                            <>
                                <span></span>
                            </>
                        )}
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={handleAddFolder}
                        >
                            Create Folder
                        </Button>
                    </Row>
                }
                bordered={false}
                style={{
                    width: '100%',
                    maxWidth: 800,
                    margin: '0 auto'
                }}
            >
                <Table
                    dataSource={combinedData}
                    columns={columns}
                    pagination={{
                        // pageSize: 10,
                        showSizeChanger: true,
                    }}
                    expandable={{
                        showExpandColumn: false
                    }}
                />

            </Card>

            <Modal
                title="Create New Folder"
                visible={isModalVisible}
                onOk={handleFolderSubmit}
                onCancel={() => setIsModalVisible(false)}
                okText="Create"
                cancelText="Cancel"
            >
                <Input
                    placeholder="Enter folder name"
                    value={newFolderName}
                    onChange={(e) => setNewFolderName(e.target.value)}
                />
            </Modal>

            <Modal
                title="Rename Folder"
                visible={isRenameModalVisible}
                onOk={handleRenameFolder}
                onCancel={() => setIsRenameModalVisible(false)}
                okText="Rename"
                cancelText="Cancel"
            >
                <Input
                    placeholder="Enter new folder name"
                    value={renameFolderName}
                    onChange={(e) => setRenameFolderName(e.target.value)}
                />
            </Modal>

            <Modal
                title="Employee List"
                visible={isUserListModalVisible}
                onCancel={handleUserListModalClose}
                footer={[
                    <Button key="cancel" onClick={handleUserListModalClose}>
                        Cancel
                    </Button>,
                    <Button
                        key="save"
                        type="primary"
                        onClick={async () => {
                            if (selectedFolderId) {
                                try {
                                    const response = await dispatch(assignFolderPermission({
                                        folderId: selectedFolderId,
                                        editFolderUserId: selectedEditUsers,
                                        userId: selectedViewUsers
                                    }));

                                    if (response.success) { // Adjust this based on your API response structure
                                        // message.success("Permissions assigned successfully.");
                                        dispatch(getFolderFiles(cfid || 0))

                                        handleUserListModalClose();
                                    } else {
                                        dispatch(getFolderFiles(cfid || 0))

                                        handleUserListModalClose();

                                        // message.error(response.message || "Failed to assign permissions.");
                                    }
                                } catch (error) {
                                    message.error("An error occurred while assigning permissions.");
                                }
                            } else {
                                message.error("No folder selected.");
                            }
                        }}
                    >
                        Save
                    </Button>,
                ]}
                bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
            >
                <Input
                    placeholder="Search Employee"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ marginBottom: 16 }}
                />

                {filteredUsers
                    .slice()
                    .sort((a, b) => a.firstName.localeCompare(b.firstName))
                    .map((user) => (
                        <Row key={user.id} gutter={16} align="middle" style={{ marginBottom: 8 }}>
                            <Col flex="auto">{`${user.firstName} ${user.lastName}`}</Col>
                            {console.log("folderContent?.folders?.createdBy", folderContent)
                            }
                            {console.log("USERid", user.id)
                            }
                            <Col>
                                <Checkbox
                                    checked={selectedViewUsers.includes(user.id)}
                                    onChange={(e) => handleViewUserChange(user.id, e.target.checked)}
                                    disabled={folderContent?.folders
                                        ?.find(folder => folder.id === selectedFolderId)?.createdBy === user.id}
                                >
                                    View
                                </Checkbox>
                            </Col>
                            <Col>
                                <Checkbox
                                    checked={selectedEditUsers.includes(user.id)}
                                    onChange={(e) => handleEditUserChange(user.id, e.target.checked)}
                                    disabled={folderContent?.folders
                                        ?.find(folder => folder.id === selectedFolderId)?.createdBy === user.id}
                                >
                                    Edit
                                </Checkbox>
                            </Col>
                        </Row>
                    ))}
            </Modal>
        </Fragment>
    );
};

export default FolderManager;